export { dom } from "./DOM/DOM";